import { PositionDetail } from '@/pages/positions/detail/PositionDetail';

/** `/positions/:id` — header with stage/portal badges, rates, properties, JD, briefings, submissions. */
export function PositionDetailPage() {
  return <PositionDetail />;
}
